import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcLeft32Icon, IcRight32Icon } from '@gem/icons';
import { AddKeyPressHandler } from '@gem/keyboard-handler';
import { IconButton, IconViewSizes } from '@gem/ui-kit';

import { IMediaGalleryState } from 'APP/types/mediaGallery';

import { IMediaGalleryFile } from '../MediaGallery.types';
import { useMediaGalleryContentPresenter } from './MediaGalleryContent.presenter';
import styles from './MediaGalleryContent.styles.m.css';
import { MediaGalleryFile } from './MediaGalleryFile/MediaGalleryFile';

interface IMediaGalleryContentProps {
  file: IMediaGalleryFile;
  galleryState: IMediaGalleryState;
}

export const MediaGalleryContent: FC<IMediaGalleryContentProps> = observer(
  ({ file, galleryState }) => {
    const { presenter, contentRef } = useMediaGalleryContentPresenter(file, galleryState);

    return (
      <div
        ref={contentRef}
        className={styles.container}
      >
        <AddKeyPressHandler
          onArrowLeft={presenter.toPrev}
          onArrowRight={presenter.toNext}
        />
        {presenter.isPrevButton && (
          <IconButton
            onClick={presenter.toPrev}
            className={classNames(styles.navigate, { [styles.show]: presenter.isShowNavigation })}
            Icon={IcLeft32Icon}
            isLoading={presenter.isPrevLoading}
            loaderColor={'primary'}
            size={IconViewSizes.XLarge}
          />
        )}
        <MediaGalleryFile
          id={file.id}
          messageId={file.message.id}
          groupId={file.message.groupId}
          payload={file.payload}
        />
        {presenter.isNextButton && (
          <IconButton
            onClick={presenter.toNext}
            size={IconViewSizes.XLarge}
            Icon={IcRight32Icon}
            className={classNames(styles.navigate, { [styles.show]: presenter.isShowNavigation })}
            loaderColor={'primary'}
            isLoading={presenter.isNextLoading}
          />
        )}
      </div>
    );
  }
);
